import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  async connect () {
    const { default: Toast } = await import('bootstrap/js/dist/toast')
    this.toastInstance = Toast.getOrCreateInstance(this.element)
    this.toastInstance.show()
  }
}
